import { Company, User } from '/src/lib/models';

/**
 * Enums
 */
export enum UserRole {
  Admin = 'admin',
  Company = 'user',
  Investor = 'lender',
  // _DontUse = '', // include an empty string to accommodate legacy bug
}

export enum UserStatus {
  Active = 'active',
  Inactive = 'inactive',
}

/**
 * List Users
 */
export type TListUsersRequest = Record<string, any>;

export type TListUsersResponse = User[];

/**
 * Get User
 */
export type TGetUserResponse = User;

/**
 * Create User
 */
export type CreateUserForm = {
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  role: UserRole;
  company?: Company;
};

export type TCreateUserRequest = {
  username: string;
  firstName: string;
  lastName: string;
  displayName: string;
  email?: string;
  password?: string;
  roles: UserRole[]; // Defaults to ['user']
  status?: UserStatus; // Defaults to 'active'
  company?: Company;
};

export type TCreateUserResponse = User;

/**
 * Update User
 */
export type UpdateUserForm = User;

export type TUpdateUserRequest = User;

export type TUpdateUserResponse = User;

/**
 * Delete User
 */
export type TDeleteUserResponse = User;

/**
 * Change Password
 */
export type ChangePasswordForm = {
  currentPassword: string;
  newPassword: string;
  verifyPassword: string;
};
